/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext, useEffect, useState } from 'react';

import { SessionContext } from '../../../context/SessionContext';
import { initializeNativeJoinSuccess } from '../../../lib/nativeUsageStore';
import { addSuccessFragment } from '../../../services/UrlService';
import { G2MJoinSuccessPage } from './G2MJoinSuccessPage';
import {
  EngagementData,
  gatherEngagementEngineData,
} from '../../../services/EngagementService';

interface Props {
  onTryAgain: () => void;
}

export const G2MJoinSuccessComponent: React.FC<Props> = ({ onTryAgain }) => {
  const { meetingId, meetingInfo } = useContext(SessionContext);
  const [engagement, setEngagement] = useState<EngagementData | null>(null);
  addSuccessFragment();
  initializeNativeJoinSuccess();
  useEffect(() => {
    gatherEngagementEngineData(meetingId).then(setEngagement);
  }, [meetingId, meetingInfo]);

  return <G2MJoinSuccessPage engagement={engagement} onTryAgain={onTryAgain} />;
};
